import { koComponent } from '../ko-utils';
import $api from '../api';

class CopyToDialog {
    constructor(params, rootPageParent) {
        this.root = params.root;
        this.callback = params.callback;

        this.projects = ko.observableArray();

        this.getProjects();

        this.selectedProjectId = ko.observable();

        this.isSubmitting = ko.observable(false);
    }

    getProjects() {
        $api.projects.getAll({}, {}, (resp) => {
            this.projects(resp.filter(i => i.uniqueCode !== window.auth.project.UniqueCode));
        });
    }

    doWork() {
        this.isSubmitting(true);

        this.callback && this.callback(this.selectedProjectId())
    }
}

export default koComponent('CopyToDialog', CopyToDialog);